import ATextarea from './Textarea';
export default ATextarea;


// WEBPACK FOOTER //
// ./src/packages/Textarea/index.js